import React from 'react';

import UserIcon from 'Components/common/UserIconComponent';
import SvgIcon from 'Components/svg/SvgIcon';
import CheckboxComponent from 'Components/common/CheckboxComponent';
import Date from 'Components/common/dateComponent';

import decode from 'Utils/entities';
import rawToReact from 'Utils/bbcode/RawToReact';

import { resetOverlay, showLoginModal, showConfirmModal } from 'Actions/UiActions';
import { updateFollowing } from 'Actions/ForumviewActions';
import { trackGAEvent } from 'Actions/adsActions';
import { toggleSelectedItem } from 'Actions/MetaActions';

class ThreadComponent extends React.Component {
	subscribeThread = ( event ) => {
		let userState = this.props.ustate, isSub, subType;
		event.stopPropagation(); // stop here

		if( userState.id ) {
			if (typeof this.props.forum !== 'undefined' ) {
				isSub = this.props.forum.isSubscribed;
				subType = 'forum';
			} else {
				isSub = this.props.thread.isSubscribed;
				subType = 'topic';
			}

			if( isSub ) {
				this.props.dispatch( showConfirmModal( 'Unsubscribe', `Would you like to unsubscribe from this ${subType}?`, () => this.props.dispatch( updateFollowing( this.props ) ) ) );
			} else {
				this.props.dispatch( updateFollowing( this.props ) );
			}

			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'followingTopic', 'uiAction', 'tap' ) );

		} else {
			// for guests show the login modal
			this.props.dispatch( resetOverlay() );
			this.props.dispatch( showLoginModal() );
			// Record the Google Analytics event.
			this.props.dispatch( trackGAEvent( false, 'followTopic', 'userAction', 'loginPrompt' ) );
		}
	};

	selectThread() {
		this.props.dispatch( toggleSelectedItem( this.props.thread.id ) );
	}

	render(){
		let { id, title, postsCount, lastDateline, dateline, unread, isSubscribed } = this.props.thread;

		let preview = this.props.showLast && this.props.thread.previewlast ? this.props.thread.previewlast : this.props.thread.preview,
			content_showed = this.props.expandedContent ?
				rawToReact( this.props.expandedContent, this.props, false )
				:
				decode( preview );

		const statsData = postsCount ?
			<div className="stats">
				<div className="stats-counter"><SvgIcon size="12px" icon="forum"/>{ postsCount.toLocaleString() } { `post${ parseInt( postsCount ) !== 1 ? 's' : '' }` }</div>
				<Date timestamp={ lastDateline } icon={ true } />
			</div> :
			<div className="stats single-right"><Date timestamp={ dateline } icon={ true } /></div>;

		const subscribe = this.props.isSubscribable ?
			<div className="subscribe" onClick={ this.subscribeThread }>
				<SvgIcon size="20px" icon="subscribe"/>
			</div> : '';

		const deleted = this.props.thread.isDeleted ?
			<div className="thread-deleted" >
				<SvgIcon size="20px" icon="delete"/>
			</div> : null;

		const user = this.props.user || { avatar: '', userName: '-' };

		let checked = !!( this.props.selectedElements && this.props.selectedElements[ id ] ),
			checkBox = this.props.isSubscribable && this.props.isSearch !== true && !deleted ?
				<CheckboxComponent
					name={ `threadSelect_${ this.props.thread.forum }` }
					id={ `threadSelect_${ id }` }
					value={ id }
					checked={ checked }
					multiple={ true }
					className={ 'inPost' }
					onChange={ () => this.selectThread() }
				/> : null;

		return (
			<div className={ `nolinks thread${ this.props.ustate.id && unread ? ' indicator' : '' }${ isSubscribed ? ' subscribed' : '' }${ deleted ? ' deleted' : '' }${ checked ? ' selected-item' : '' }` }>
				<div className="left">
					<UserIcon user={ user } layout="nolocation"/>
				</div>
				<div className="right">
					<div className="thread-info">
						{ checkBox }
						{ subscribe }
						{ deleted }
					</div>
					<div className="title">
						{ rawToReact( title ) }
					</div>
					{ statsData }
					<div className="topic-preview">
						{ content_showed }
					</div>
				</div>
			</div>
		)
	}
}

export default ThreadComponent;


// WEBPACK FOOTER //
// ./src/components/threads/ThreadComponent.js